import { ItemList } from '../orm'

class YocoPayment extends ItemList {
    getEntityKey() {
        return "customer/purchased_trolley/verify_yoco_payment"
    }

    verifyPayment({ payment_status, payment_ref, has_timed_out }) {
      return this.saveNewObject({
        callback_status: payment_status,
        payment: payment_ref,
        has_timed_out: has_timed_out,
      })
    }
    
}

export const yocoPayment = new YocoPayment("yoco_payment_default")


